// AI Generated Test
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { ExporterService } from '@client/app/modules/export/services/exporter.service';
import { HistoryPrepareService } from '@client/app/pages/global/changes-history/dashboard/tables/history-prepare.service';

@Component({
    selector: 'changes-history-dashboard-table-qa',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-48">
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-8 col-lg-8">
                            {{'Crawled at' | translate}}
                        </th>
                        <th class="text-right col-4" [ngClass]="{'col-lg-7': domain?.scan?.scan_documents, 'col-lg-8': !domain?.scan?.scanDocuments}">
                            <span class="visible-print-block">{{'Pages' | translate}}</span>
                            <span class="hidden-print">{{'Pages crawled' | translate}}</span>
                        </th>
                        <th class="text-right col-4 col-lg-7" *ngIf="domain?.scan?.scan_documents">
                            <span class="visible-print-block">{{'Documents' | translate}}</span>
                            <span class="hidden-print">{{'Documents crawled' | translate}}</span>
                        </th>
                        <th class="text-right col-8 col-lg-9">
                            {{'Domain compliance' | translate}}
                        </th>
                        <th *ngIf="allowVerticalAverage" class="text-right col-8 col-lg-9">
                            {{'Comparison to average' | translate}}
                            <span class="fas fa-question-circle hidden-print"
                                  [triggers]="'focus hover'"
                                  ngbTooltip="{{'The average score for domains within your industry.' | translate}}">
                            </span>
                        </th>
                        <th class="text-right" [ngClass]="{'col-18 col-lg-10': domain?.scan?.scan_documents, 'col-22 col-lg-16': !domain?.scan?.scanDocuments}">
                            {{'QA errors' | translate}}
                        </th>
                        <th class="text-right col-6 col-lg-7">
                            <span class="visible-print-block">{{'Changes' | translate}}</span>
                            <span class="hidden-print">{{'Changes since previous crawl' | translate}}</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let story of historyOutput">
                        <td class="text-v-middle">
                            <user-date [twoLines]="true"
                                       [date]="story.post_processing_done_at || story.date">
                            </user-date>
                        </td>
                        <td class="text-v-middle text-right">
                            {{story.page_count}}
                        </td>
                        <td class="text-v-middle text-right" *ngIf="domain?.scan?.scan_documents">
                            {{story.documents_count}}
                        </td>
                        <td class="text-right text-v-middle">
                            <table-css-compliance
                                    *ngIf="story.hasCompliance"
                                    class="donut"
                                    [totalCount]="totalCount"
                                    [errorCount]="story.error">
                            </table-css-compliance>
                            <span *ngIf="!story.hasCompliance" translate>
                                N/A
                            </span>
                        </td>
                        <td *ngIf="allowVerticalAverage" class="text-right text-v-middle comparisonToAverage">
                            <span *ngIf="story.comparisonToAverageStyle === 'positive'" class="positive">
                                <span class="fas fa-chevron-up"></span> {{story.comparisonToAverage}}
                            </span>
                            <span *ngIf="story.comparisonToAverageStyle === 'negative'" class="negative">
                                <span class="fas fa-chevron-down"></span> {{story.comparisonToAverage}}
                            </span>
                            <span *ngIf="story.comparisonToAverageStyle === 'neutral'">
                                {{story.comparisonToAverage}}
                            </span>
                            <span *ngIf="!story.hasCompliance" translate>
                                N/A
                            </span>
                        </td>
                        <td class="text-v-middle text-right">
                            <span class="outer-r-mini"
                                  *ngFor="let opportunity of qaErrorOptions; trackBy: trackByIndex">
                                <span class="{{opportunity.icon}}"
                                      [ngClass]="opportunity.color">
                                </span>
                                <span>{{story[opportunity.attr]}}</span>
                            </span>
                        </td>
                        <td class="text-v-middle text-right"
                            [ngClass]="story.changeValueColorClass">
                            <span [ngClass]="story.changeValueIconClass">
                            </span>
                            {{story.changePercentageValue}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class QaComponent implements OnInit, OnChanges, OnDestroy {
    @Input() history: any;
    @Input() domain: any;

    historyOutput: any[] = [];
    issuesStack: string[] = ['dead_links_count', 'dead_images_count', 'spelling_errors_confirmed_count'];
    totalCount: number = 100;
    allowVerticalAverage: boolean = false;
    qaErrorOptions: any[] = [];

    constructor (
        private activeFeatureService: ActiveFeatureService,
        private exporterService: ExporterService,
        private historyPrepareService: HistoryPrepareService,
    ) {}

    ngOnInit (): void {
        this.getQAErrorOptions();
        this.exporterService.connectToCSVExporter('qa', () => {
            return this.historyOutput;
        });
    }

    ngOnChanges (): void {
        if (this.history) {
            this.allowVerticalAverage = this.activeFeatureService.isFeatureActivePure('monsido_score');
            this.historyOutput = this.historyPrepareService.prepareQAHistory(this.history);
            this.historyOutput.sort((a, b) => {
                return b.id - a.id;
            });
        }
    }

    ngOnDestroy (): void {
        this.exporterService.disconnectFromCSVExporter('qa');
    }

    trackByIndex (index: number): number {
        return index;
    }

    private getQAErrorOptions (): void {
        this.qaErrorOptions = [
            {
                icon: 'fas fa-unlink',
                attr: 'dead_links_count',
                color: 'text-danger',
            },
            {
                icon: 'fas fa-image',
                attr: 'dead_images_count',
                color: 'text-purple',
            },
            {
                icon: 'fas fa-language',
                attr: 'spelling_errors_confirmed_count',
                color: 'text-warning',
            },
        ];
    }
}
